<div>
  <form [formGroup]="contatoForm" id="contatoForm">
    <div class="row">
      <div class="col-sm-6 form-group my-2">
        <label for="tipoContato" class="form-label">Tipo de Contato</label>
        <nz-select formControlName="tipoContato" (ngModelChange)="onTipoContatoChange($event)" nzShowSearch nzAllowClear
          nzPlaceHolder="Tipo de Contato" nzSize="large" [compareWith]="compareFn">
          <nz-option [nzValue]="item" [nzLabel]="item?.nomeTipoContato" *ngFor="let item of tipoContatoList"></nz-option>
        </nz-select>
      </div>

      <div class="col-sm-6 form-group my-2">
        <label nz-checkbox formControlName="flagPrincipal" (ngModelChange)="checkIfPrincipal($event)">Principal</label>
      </div>
    </div>


    <div class="row g-2">
      <div class="col-sm-6 form-group my-2">
        <label for="pais" class="form-label">Pais</label>
        <nz-select formControlName="pais" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
          [compareWith]="compareFn">
          <nz-option [nzValue]="item" [nzLabel]="item.nome" *ngFor="let item of paisesList" />
        </nz-select>
      </div>

      <div class="col-sm-4 form-group">
        <label for="enderecoCep" class="form-label">CEP</label>
        <nz-input-group nzSize="large">
          <input nz-input id="enderecoCep" formControlName="enderecoCep" placeholder="CEP" [ngModel]="cep"
            (ngModelChange)="cep = $event" (focusout)="onCepBlur()" />
        </nz-input-group>
      </div>

      <div class="col-sm-6 form-group my-2">
        <label for="enderecoUf" class="form-label">Estado</label>
        <nz-select formControlName="enderecoUf" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
          [compareWith]="compareFn">
          <nz-option [nzValue]="item" [nzLabel]="item.nome" *ngFor="let item of ufList" />
        </nz-select>
      </div>
      <div></div>

      <div class="col-sm-6 form-group my-2">
        <label for="enderecoMunicipio" class="form-label">Cidade</label>
        <nz-select formControlName="enderecoMunicipio" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
          [compareWith]="compareFn">
          <nz-option [nzValue]="item" [nzLabel]="item.nome" *ngFor="let item of cidadeList" />
        </nz-select>
      </div>

      <div class="col-sm-6 form-group my-2">
        <label for="enderecoBairro" class="form-label">Bairro</label>
        <nz-input-group nzSize="large">
          <input nz-input id="enderecoBairro" formControlName="enderecoBairro" placeholder="bairro" />
        </nz-input-group>
      </div>


      <div></div>
      <div class="col-sm-6 form-group">
        <label for="enderecoLogradouro" class="form-label">Lougradouro</label>
        <nz-input-group nzSize="large">
          <input nz-input id="enderecoLogradouro" formControlName="enderecoLogradouro" placeholder="Lougradouro"
            nzSearch />
        </nz-input-group>
      </div>
      <div class="col-sm-6 form-group">
        <label for="enderecoNumero" class="form-label">Número</label>
        <nz-input-group nzSize="large">
          <input nz-input id="enderecoNumero" formControlName="enderecoNumero" placeholder="Número" nzSearch />
        </nz-input-group>
      </div>
      <div class="col-sm-8 form-group my-2">
        <label for="enderecoComplemento" class="form-label">Complemento</label>
        <nz-input-group nzSize="large">
          <input nz-input id="enderecoComplemento" formControlName="enderecoComplemento" placeholder="Complemento"
            nzSearch />
        </nz-input-group>
      </div>


      <div class="col-sm-1 form-group">
        <label for="ddi" class="form-label">DDI</label>
        <nz-input-group nzSize="large">
          <input nz-input formControlName="ddi" placeholder="DDI" />
        </nz-input-group>

      </div>


      <div class="col-sm-5 form-group">
        <label for="telefone" class="form-label">Telefone</label>
        <nz-input-group nzSize="large">
          <input nz-input formControlName="telefone" placeholder="(xx)xxxx-xxxx"
            [value]="contatoForm.get('telefone')?.value | telefone" />
          <div
            *ngIf="contatoForm.get('telefone')?.invalid && (contatoForm.get('telefone')?.dirty || contatoForm.get('telefone')?.touched)">
            <div *ngIf="contatoForm.get('telefone')?.errors?.['required']" class="text-danger">Telefone é obrigatório.
            </div>
            <div *ngIf="contatoForm.get('telefone')?.errors?.['telefone']" class="text-danger">Telefone inválido.</div>
            <div *ngIf="contatoForm.get('telefone')?.errors?.['pattern']" class="text-danger">Formato do Telefone
              inválido.</div>
          </div>
        </nz-input-group>
      </div>

      <div class="col-sm-6 form-group">
        <label for="email" class="form-label">E-mail</label>
        <app-email-search-select formControlName="email" placeholder="E-mail"></app-email-search-select>
        <div
          *ngIf="contatoForm.get('email')?.invalid && (contatoForm.get('email')?.dirty || contatoForm.get('email')?.touched)">
          <div *ngIf="contatoForm.get('email')?.errors?.['required']" class="text-danger">E-mail é obrigatório.</div>
        </div>
      </div>


      <div class="col-sm-6 form-group">
        <label for="siteUrl" class="form-label">Site</label>
        <nz-input-group nzSize="large">
          <input nz-input formControlName="siteUrl" placeholder="Url Site" />
        </nz-input-group>
      </div>
    </div>
  </form>
  <div class="row mt-4">
    <div class="col-12 d-flex justify-content-end">
      <button nz-button nzType="primary" (click)="handleOk()">{{ inserir ? 'Adicionar' : 'Editar' }}</button>
      <button nz-button nzType="default" class="ms-2" (click)="handleCancel()">Cancelar</button>
    </div>
  </div>
</div>
